

require('components/json2/json2');

require('components/es5-shim/es5-shim');

require('components/es5-shim/es5-sham');

require('components/EventShim/eventShim');

require('jqueryMask');


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-shims/dist/index.js
// module id = ./components/xo-ui-shims/dist/index.js
// module chunks = 0